const ActiveStorage = () => import('activestorage');

export default class ActiveStorageUploader {
  constructor({ progressHandler, completeHandler, token }) {
    this.progressHandler = progressHandler;
    this.completeHandler = completeHandler;
    this.token = token;
  }

  async upload(file) {
    const { DirectUpload } = await ActiveStorage();

    this.uploader = new DirectUpload(file, '/api/api/direct_uploads', this);
    this.uploader.create(this.completeHandler);
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener('progress', event => this.directUploadDidProgress(event));
  }

  directUploadDidProgress(event) {
    if (!this.progressHandler) return;

    this.progressHandler(event.loaded / event.total);
  }
}
